import api from './api';

export default {
    async login(payload) {
        try {
            const headers = {
                'Content-Type': 'application/json', 
            };
            const response = await api.post(`login/user`, payload, {
                headers,
            });
            return response.data;
        } catch (error) {
            console.error('Erro ao fazer login:', error);
                throw error;
        }
    },
}

